import { render, staticRenderFns } from "./MinisiteTransferFiles.vue?vue&type=template&id=5e895df8&scoped=true&"
import script from "./MinisiteTransferFiles.vue?vue&type=script&lang=js&"
export * from "./MinisiteTransferFiles.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteTransferFiles.vue?vue&type=style&index=0&id=5e895df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e895df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e895df8')) {
      api.createRecord('5e895df8', component.options)
    } else {
      api.reload('5e895df8', component.options)
    }
    module.hot.accept("./MinisiteTransferFiles.vue?vue&type=template&id=5e895df8&scoped=true&", function () {
      api.rerender('5e895df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteTransferFiles.vue"
export default component.exports